import store from 'pc-sales/store';
import { get, post } from 'pc-sales/utils/http';

export class SystemApi {
    // 获取系统设置
    setting = (data: { keys: Array<string> }) => get('/v2/platform/setting', data);

    // 获取菜单
    getMenu = (data: { utype?: string; role_id?: string }) => get('/v2/platform/menu', data);

    // 获取钱包设置
    getWallet = () => get('/v2/platform/wallet');

    // 获取链接对应二维码
    qrCode = (data: { url: string }) => post('/v2/platform/qrCode', data);

    // 获取语言配置
    languageConfig = () => get('/v2/platform/language');

    // 获取系统设置
    getSetting = (data: { keys: Array<string> }) => {
        // 未登录时访问公开设置项接口
        const userState = (store.getState() as any).user;
        const isLogin = !!(userState && userState.get('status') && userState.get('status').uuid);
        if (isLogin) {
            return get('/v2/platform/setting', data);
        }
        return get('/v2/platform/setting/public', data);
    };

    // crm-client入口权限校验
    crmClient = (data: { lang: string; type: string }) => get('/v2/platform/crmClient', data);

    // crm-client入口token校验
    callCrmClient = (data: any) => get('/v2/platform/callCrmClient', data);

    // 获取银行列表
    getBanks = (data: any) => get('/v2/control/bank', data);

    // 获取银行国家列表
    getBankCountrys = (data: any) => get('/v2/control/bankCountry', data);
}

export default new SystemApi();
